import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const ShareV2 = createIcon({
  displayName: "Sharev2",
  viewBox: "0 0 19 17",
  path: (
    <>
      <title>Sharing Icon</title>
      <svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7218 7.83226L11.1218 0.276528C10.9889 0.144482 10.8196 0.0545628 10.6354 0.0181371C10.4511 -0.0182887 10.2602 0.000414575 10.0866 0.0718824C9.91302 0.14335 9.76466 0.264374 9.66027 0.419653C9.55588 0.574933 9.50014 0.757497 9.5001 0.944266V4.2924C6.90495 4.53116 4.49281 5.72408 2.73573 7.63773C0.978656 9.55138 0.00310818 12.048 0 14.639V16.0557C0.000149965 16.2518 0.0616649 16.4429 0.176012 16.6027C0.29036 16.7624 0.451872 16.8828 0.638146 16.9471C0.82442 17.0115 1.02622 17.0166 1.21557 16.9618C1.40491 16.907 1.5724 16.795 1.69482 16.6413C2.62554 15.541 3.76751 14.636 5.054 13.9794C6.34049 13.3228 7.74571 12.9277 9.18755 12.8172C9.23505 12.8115 9.3538 12.802 9.5001 12.7926V16.0557C9.50014 16.2425 9.55588 16.4251 9.66027 16.5803C9.76466 16.7356 9.91302 16.8566 10.0866 16.9281C10.2602 16.9996 10.4511 17.0183 10.6354 16.9819C10.8196 16.9454 10.9889 16.8555 11.1218 16.7235L18.7218 9.16774C18.9 8.99063 19 8.75044 19 8.5C19 8.24956 18.9 8.00938 18.7218 7.83226ZM11.4001 13.7758V11.8056C11.4001 11.5551 11.3 11.3149 11.1219 11.1378C10.9437 10.9607 10.7021 10.8612 10.4501 10.8612C10.2079 10.8612 9.2189 10.9084 8.9662 10.9414C6.40579 11.176 3.96859 12.1431 1.94942 13.7257C2.1786 11.6427 3.1726 9.7168 4.74108 8.31693C6.30956 6.91705 8.34231 6.14152 10.4501 6.13883C10.7021 6.13883 10.9437 6.03933 11.1219 5.86221C11.3 5.68508 11.4001 5.44485 11.4001 5.19437V3.22421L16.7069 8.5L11.4001 13.7758Z"
          fill="#1D1D1B"
        />
      </svg>
    </>
  )
});
